// contentReducer.js
import { SAVE_CONTENT } from "./constants";

const initialContentState = {
  content: []
};

export const contentReducer = (state = initialContentState, action) => {
  switch (action.type) {
    case SAVE_CONTENT:
      return {
        ...state,
        content: [...state.content, action.payload],
      };
    default:
      return state;
  }
};
